export const getBrowserLanguage = () => {
    if (typeof window === 'undefined') {
      return 'en';
    }
  
    const first = window.navigator.languages
      ? window.navigator.languages[0]
      : null;
  
    const lang = first ||
      window.navigator.language ||
      window.navigator.browserLanguage ||
      window.navigator.userLanguage;
  
    return lang.split("-")[0];
  }
  